import axios from "@/axios";

const getDefaultState = () => ({
    silos: []
});

const state = getDefaultState();

const mutations = {
    SET_SILOS(state, silos) {
        state.silos = silos;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
}

const actions = {
    async fetchSilosByUnidade({ commit }, unidade) {
        try {
            const response = await axios.get(`/unidades/${unidade}/silos`);
            commit('SET_SILOS', response.data.silos);
        } catch (error) {
            console.error("Erro ao buscar silos:", error);
			throw error;
        }
    },
    async fetchSilosByUnidadeNoStore(_, unidade) {
        try {
            const response = await axios.get(`/unidades/${unidade}/silos`);
            return response.data.silos;
        } catch (error) {
            console.error("Erro ao buscar silos:", error);
            throw error;
        }
    },
    async updateSilosEmLote(_, { params }) {
        try {
            const response = await axios.post('/silos/aeracao/lote/update', params);
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar silos:", error);
			throw error;
        }
    },
    async getBatchStatus(_, batchId) {
        try {
            const response = await axios.get(`/silos/aeracao/lotes/${batchId}/status`);
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar status do lote:", error);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    actions,
    mutations,
    state
}